<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    bookmakerId: {
      type: String,
      required: true,
    },
    eventId: {
      type: [String, Number],
      required: true,
    },
    betType: {
      type: String,
      required: true,
    },
    selectionIds: {
      type: Array,
      default: () => [],
    },
    isRacingRelated: {
      type: Boolean,
      default: () => true,
    },
  },
  computed: {
    ...mapGetters({
      odds: 'RacingOddsComparisonTable/getOdds',
      events: 'RacingOddsComparisonTable/getEvents',
    }),
    marketPercentage() {
      const { events, eventId, bookmakerId, betType, odds, selectionIds, isRacingRelated } = this;
      let marketPercentage = 0;
      let eventOddsKeys = events[parseInt(eventId)];
      if (!eventOddsKeys) {
        return marketPercentage;
      }

      // Filter by bookmaker
      eventOddsKeys = eventOddsKeys.filter(key => {
        return key ? key.indexOf('-' + bookmakerId + '-') !== -1 : '';
      });

      // Filter by bet type
      eventOddsKeys = eventOddsKeys.filter(key => {
        const searchString = '-' + betType;
        return key.substring(key.length - searchString.length, key.length) === searchString;
      });

      const oddsItems = [];
      for (const key of eventOddsKeys) {
        if (odds[key] !== undefined) {
          oddsItems.push(odds[key]);
        }
      }

      try {
        for (let k = 0, l = oddsItems.length; k < l; k++) {
          const priceValue = oddsItems[k].price.value;
          const { selectionId } = oddsItems[k];
          if (isRacingRelated && !selectionIds.includes(selectionId)) return;
          if (priceValue !== 0) {
            marketPercentage += 100 / priceValue;
          }
        }
      } catch (error) {
        console.log(error);
      }

      return Math.round(marketPercentage);
    },
  },
};
</script>

<template>
  <span v-if="marketPercentage > 0" v-html="marketPercentage"></span>
</template>
